import Toast, { BaseToast } from 'react-native-toast-message'
import { SafeAreaView } from 'react-native-safe-area-context'
import { Platform, StyleSheet } from 'react-native'
import { mesaColorNames, typography } from '@/src/common/theme'

export function MesaToast() {
  return (
    <Toast
      config={{
        success(props) {
          return (
            <SafeAreaView>
              <BaseToast
                {...props}
                style={[
                  styles.style,
                  { backgroundColor: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'] },
                ]}
                contentContainerStyle={styles.contentContainerStyle}
                text1Style={styles.text1Style}
              />
            </SafeAreaView>
          )
        },
        error(props) {
          return (
            <SafeAreaView>
              <BaseToast
                {...props}
                style={[styles.style, { backgroundColor: mesaColorNames['Mesa Third #E78A43'] }]}
                contentContainerStyle={styles.contentContainerStyle}
                text1Style={styles.text1Style}
              />
            </SafeAreaView>
          )
        },
      }}
    />
  )
}

const styles = StyleSheet.create({
  style: {
    borderLeftWidth: 0,
    borderRadius: 8,
    height: 'auto',
    ...(Platform.OS === 'web' && { width: 'auto' }),
  },
  contentContainerStyle: {
    height: 'auto',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 8,
  },
  text1Style: {
    color: mesaColorNames['Mesa - Brand/Blackish #222222'],
    marginBottom: 0,
    ...typography['paragraph/md'],
  },
})
